export const searchIconCSSPartName = 'bv-search-icon'
export function updateSearchIconStyles(shadowRoot) {
  const searchIcon = shadowRoot.querySelector('div[role="search"]')?.querySelector('svg')
  if (!searchIcon) return

  searchIcon.setAttribute('part', 'bv-search-icon')
  searchIcon.setAttribute('color', 'currentColor')
  searchIcon.querySelectorAll('g, path').forEach(el => {
    el.setAttribute('fill', 'currentColor')
  })
}
